import React from 'react';
import Modal from '../../../../../component/modal/Modal';
import Button from '../../../../../component/ui/Button';

export default function DeactivateConfirmAccountModal({
	isOpenModal,
	setIsOpenModal,
	accountId,
	handleDeactivateAccount,
}) {
	return (
		<Modal
			className="confirmatinBoxModal"
			title={'Are You Sure?'}
			isOpen={isOpenModal}
			onClose={() => {
				setIsOpenModal(false);
			}}
			cancelButton={() => {
				setIsOpenModal(false);
			}}
		>
			<div
				className="fs-4 fw-semibold text-center"
				style={{ color: '#979797' }}
			>
				This account will not be available for new transactions, but old transactions and reports
				will remain unchanged.
			</div>
			<div className="d-flex align-items-center justify-content-center mt-4 gap-4">
				<Button
					type="button"
					button={`Cancel`}
					className="mt-0 px-4 btn-gray relative"
					onClick={() => {
						setIsOpenModal(false);
					}}
				/>
				<Button
					type="button"
					button={`Confirm`}
					className="mt-0 px-4 btn-primary relative"
					onClick={() => handleDeactivateAccount(accountId)}
				/>
			</div>
		</Modal>
	);
}
